import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import _ from "lodash";
import Pagination from '../../page/Pagination'
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
const log = new Logger('INTRA_INVOICE_DETAILS', LOG_LEVELS.DEBUG);

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.STANDARD_LEVEL_TWO_PAGE_SIZE,
    page: 0,
    startAt: 1
};
class IntrastatInvoiceDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: DEFAULT_PAGINATION_CONFIG,
            initialLoad: true,
            sorted: []
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }

    getColumns() {
        let formatFloatValue = (floatValue) => {
            const parsedValue = parseFloat(floatValue);
            return typeof parsedValue === 'number' ? parsedValue.toFixed(2) : floatValue;
        };

        const totalStatisticalValue = this.props.lineDetails && this.props.lineDetails.statisticalValue;
        const totalCommercialValue = this.props.lineDetails && this.props.lineDetails.commercialValue;

        //React Table cols
        const cols = [
            {
                Header: LANGUAGES_CONTROLLER.format(this.props.languages, 'IntraLine_Invoices'), accessor: 'invoiceNumber',
                Footer: (
                    <span className={withFullStoryExclude()}>
                        <strong>{LANGUAGES_CONTROLLER.format(this.props.languages, 'IntraLine_Total')}</strong>
                    </span>
                )
            },
            {
                Header: LANGUAGES_CONTROLLER.format(this.props.languages, 'IntraLine_CommercialVal'), id: 'commercialValue', accessor: d => formatFloatValue(d.commercialValue), style: { textAlign: "right" },
                className: withFullStoryExclude(),
                Footer: (
                    <span className={withFullStoryExclude()}>
                        {formatFloatValue(totalCommercialValue)}
                    </span>
                )
            },
            {
                Header: LANGUAGES_CONTROLLER.format(this.props.languages, 'IntraLine_StatVal'), id: 'statisticalValue', accessor: d => formatFloatValue(d.statisticalValue), style: { textAlign: "right" },
                className: withFullStoryExclude(),
                Footer: (
                    <span className={withFullStoryExclude()}>
                        {formatFloatValue(totalStatisticalValue)}
                    </span>
                )
            },
        ];
        return cols;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchIntrastatData(): ');
        let { page, pageSize, sorted } = state;
        //If it's a sort request just return, as we don't need re-fetch the data
        if(_.isArray(sorted) && !_.isEmpty(sorted) && sorted !== this.state.sorted) {
            this.setState({
              sorted: state.sorted
            });
            return;
          }
        
        //To set default/hidden properties of react table
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.sorted = [];
        }

        pageSize = Object.is(pageSize, NaN) ? TableConfig.STANDARD_LEVEL_TWO_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,
            pageSize: pageSize,
            page: page,
            startAt: startAt + 1
        });
        this.setState({
            pagination: pagination,
            sorted: []
        });

        if (!this.state.initialLoad) {
            this.props.onFetchData(pagination);
        }
        else {
            this.setState({ initialLoad: false });
        }

    }    

    render() {
        log.debug('IntrastatInvoiceDetails');
        log.debug('render(): ', this.props);

        const data = (this.props.intrastatDetails && this.props.intrastatDetails.details) || [];

        let pagination = this.state.pagination || Object.assign({}, DEFAULT_PAGINATION_CONFIG);
        let totalCount = (this.props.lineDetails && this.props.lineDetails.totalCount) || 0;
        pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
        const columns = this.getColumns();

        let sortedData = data;
        if (this.viewTable && this.viewTable.state && !_.isEmpty(this.viewTable.state.sorted)) {  
            this.viewTable.state.page = pagination.page;
            sortedData = _.orderBy(
              data,
              this.viewTable.state.sorted.map(sort => {
                return row => {
                  let value = row[sort.id]; 
                  if (value === null || value === null) {
                      return -Infinity;
                  }
                  return typeof value === "string" ?
                    value.toLowerCase() :
                    value;
                };
              }),
              this.viewTable.state.sorted.map(d => (d.desc ? "desc" : "asc"))
            );
        }

        log.debug('render(): IntrastatData: ', data);

        const NoDataComponent = props => (
            <NoData
                noDataText="ecListingFilingValues_NoData"
                {...props}
            />
        )

        return (
            <div>
                <ReactTable                   
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    minRows={0}
                    maxRows={0}
                    ref={ref => this.viewTable = ref}
                    data={sortedData}
                    columns={columns}
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(data) ? 'mb30 hide-header' : 'mb30'}
                    PaginationComponent={Pagination}
                    showPagination={totalCount > 0}

                />
                <br />
            </div>
        );
    }
}


IntrastatInvoiceDetails.defaultProps = {
    onFetchData: () => { },
    lineDetails:{}
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        languages: state.languages,
        intrastatDetails: (state.filing && state.filing.intrastatDetails) || []
    };
}

function mapDispatchersToProps(dispatch) {
    log.debug('mapDispatchersToProps(): ');
    let dispatcherProps = {};
    log.debug('mapDispatchersToProps(): dispatcherProps: ', dispatcherProps);
    return dispatcherProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(IntrastatInvoiceDetails);
